import React from 'react';
import { V2Button } from '../../shared/custom-ui/v2-components';

interface Props {
    editMode: boolean;
    updating: boolean;
    loading: boolean;
    onEdit: () => void;
    onSave: () => void;
    onCancel: () => void;
    hasChanges?: boolean;
}

const EditSaveCancelButtons: React.FC<Props> = ({
    editMode,
    updating,
    loading,
    onEdit,
    onSave,
    onCancel,
    hasChanges
}) => {
    const isDisabled = updating || loading;

    return (
        <div className="flex justify-end space-x-3">
            {editMode ? (
                <>
                    <V2Button
                        onClick={onSave}
                        disabled={isDisabled || !hasChanges}
                        variant="primary"
                        loading={updating}
                        className="flex items-center gap-2 hover:bg-blue-700"
                    >
                        Save
                    </V2Button>

                    <V2Button
                        onClick={onCancel}
                        disabled={isDisabled}
                        variant="danger"
                        className="hover:bg-red-700"
                    >
                        Cancel
                    </V2Button>
                </>
            ) : (
                <V2Button
                    onClick={onEdit}
                    disabled={loading}
                    variant="primary"
                    className="hover:bg-blue-700"
                >
                    Edit
                </V2Button>
            )}
        </div>
    );
};

export default EditSaveCancelButtons;
